import { render, staticRenderFns } from "./SOnoff.vue?vue&type=template&id=731bdd52"
import script from "./SOnoff.vue?vue&type=script&lang=js"
export * from "./SOnoff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports